import React, { useEffect, useContext, useState } from "react";
import { LoginLayout, Toast } from "@app/components";
import { AuthContext } from "@app/providers";
import { useLocation } from "@app/utils";
import { getDefaultUrl } from "@app/routes/route-helpers";

export default function SignIn() {
  const { userInfo }: any = useContext(AuthContext);
  const { navigate } = useLocation();
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [showToast, setShowToast] = React.useState(false);

  useEffect(() => {
    if (userInfo && userInfo.sessionToken) {
      const { userJson = {} } = userInfo;
      const defaultUrl: string = getDefaultUrl(userJson);
      navigate(defaultUrl);
    }
    const platform = window.navigator.platform
    // if (platform) {
    //   setShowToast(true);
    //   setToastMessage({
    //     type: "error",
    //     message: platform,
    //   });
    // }
    // setTimeout(()=>{
    //   setShowToast(false)
    // },100)

    // setShowToast(true);
    // setToastMessage({
    //   type: "error",
    //   message: platform,

  }, [userInfo, navigate]);

  return (
    <>
      <LoginLayout path="/sign-in" label="Sign In">

      </LoginLayout>
      {/* <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          onClose={() => setShowToast(false)}
        /> */}
    </>
  );
}
